import { injectable } from "inversify";
import { SocialModelBase, SocialPlatformProvider } from "@dp-instant/social";
import { IUserData } from "@dp-instant/interfaces";
import { UserDataTelegram } from "./UserDataTelegram";
import { TelegramUser } from "./TelegramUser";

@injectable()
export class SocialModelTelegram extends SocialModelBase {
    readonly cookie: IUserData = new UserDataTelegram();

    private _me: TelegramUser;

    constructor() {
        super();
        const tgUser = (window as any).Telegram?.WebApp?.initDataUnsafe?.user;
        this._me = new TelegramUser(
            String(tgUser?.id ?? "0"),
            tgUser?.first_name ?? "Player",
            tgUser?.photo_url ?? ""
        );
    }

    get me(): TelegramUser { return this._me; }
    get inSolo(): boolean { return true; }
    get inGroup(): boolean { return false; }
    get socialPlatform(): SocialPlatformProvider { return "tg" as any; }
}
